// GENERADO POR pricing-system/publicar_viales_web.py — NO EDITAR A MANO.
// Un vial por SKU: la etiqueta trae el gramaje impreso, así que la foto
// tiene que cambiar cuando el cliente cambia de presentación.
export const VIAL_SKUS = new Set([
  '10AMINO1MQ-10MG',
  '10AMINO1MQ-50MG',
  '5AMINO1MQ-10MG',
  '5AMINO1MQ-50MG',
  '5AMINO1MQ-5MG',
  'ACIDOACETICO-10ML',
  'ACIDOACETICO-3ML',
  'ACIDOACETICO-5ML',
  'ACTH139-5MG',
  'ADIPOTIDA-10MG',
  'ADIPOTIDA-2MG',
  'ADIPOTIDA-5MG',
  'ADMAX-10MG',
  'ADMAX-5MG',
  'AGUABACTERIOST-10ML',
  'AGUABACTERIOST-3ML',
  'AHKCU-100MG',
  'AHKCU-50MG',
  'AICAR-100MG',
  'AICAR-50MG',
  'ALCOHOLBENCILICO-10ML',
  'ALCOHOLBENCILICO-3ML',
  'AOD9604-10MG',
  'AOD9604-2MG',
  'AOD9604-5MG',
  'ARA290-10MG',
  'ARA290-16MG',
  'B121MGML-1MGML10ML',
  'B733-10MG',
  'B733-2MG',
  'BOTULINUMTOXIN-100IU',
  'BPC157-10MG',
  'BPC157-20MG',
  'BPC157-2MG',
  'BPC157-5MG',
  'BPC15710MGTB50-20MG',
  'BPC1575MGTB500-10MG',
  'BRONCHOGEN-10MG',
  'CAGRILINTIDA-10MG',
  'CAGRILINTIDA-2MG',
  'CAGRILINTIDA-5MG',
  'CAGRISEMA25MG2-5MG',
  'CARDIOGEN-20MG',
  'CARTALAX-20MG',
  'CEREBROLYSIN-60MG',
  'CJC1295CONDAC-2MG',
  'CJC1295CONDAC-5MG',
  'CJC1295NODAC5M-10MG',
  'CJC1295SINDAC-10MG',
  'CJC1295SINDAC-2MG',
  'CJC1295SINDAC-5MG',
  'CORTAGEN-20MG',
  'CRYSTAGEN-20MG',
  'DSIP-10MG',
  'DSIP-2MG',
  'DSIP-5MG',
  'DULAGLUTIDA-10MG',
  'DYSPORT-500U',
  'EPITALON-50MG',
  'EPITHALON-10MG',
  'EPITHALON-50MG',
  'EPO-3000IU',
  'FOLLISTATIN-1MG',
  'FOXO4-10MG',
  'FOXO4-2MG',
  'FRAGMENT1723-10MG',
  'GDF8-1MG',
  'GHKCU-100MG',
  'GHKCU-50MG',
  'GHRP2ACETATE-10MG',
  'GHRP2ACETATE-15MG',
  'GHRP2ACETATE-5MG',
  'GHRP6ACETATE-10MG',
  'GHRP6ACETATE-5MG',
  'GLOWBPC15710MG-70MG',
  'GLUTATION-1500MG',
  'GLUTATION-600MG',
  'GONADORELINACE-2MG',
  'GONADORELINACE-5MG',
  'HCG-10000IU',
  'HCG-1000IU',
  'HCG-2000IU',
  'HCG-5000IU',
  'HEXARELINACETA-2MG',
  'HEXARELINACETA-5MG',
  'HGH-24IU',
  'HGH-36IU',
  'HGH-40IU',
  'HGHFRAGMENT176-10MG',
  'HGHFRAGMENT176-12MG',
  'HGHFRAGMENT176-15MG',
  'HGHFRAGMENT176-1MG',
  'HGHFRAGMENT176-2MG',
  'HGHFRAGMENT176-5MG',
  'HMG-75IU',
  'HUMANIN-10MG',
  'HUMANIN-20MG',
  'HUMSCCELULASMA-100MIL',
  'IGF1LR3-01MG',
  'IGF1LR3-1MG',
  'IPAMORELIN-10MG',
  'IPAMORELIN-2MG',
  'IPAMORELIN-5MG',
  'KISSPEPTINA10-10MG',
  'KISSPEPTINA10-5MG',
  'KLOWBPCGHKCUTB-80MG',
  'KPV-10MG',
  'KPV-5MG',
  'LCARNITINE-1200MG',
  'LCARNITINE-2MG',
  'LCARNITINE-400MG',
  'LCARNITINE-600MG',
  'LEMONBOTTLE-10ML',
  'LIPOC-10ML',
  'LIRAGLUTIDA-10MG',
  'LIRAGLUTIDA-30MG',
  'LIRAGLUTIDA-5MG',
  'LL37-5MG',
  'MATRIXYL-10MG',
  'MAZDUTIDA-10MG',
  'MAZDUTIDA-5MG',
  'MELANOTANI-10MG',
  'MELANOTANII-10MG',
  'MELATONINA-10MG',
  'MGF-2MG',
  'MICLIPOCB12-10MG',
  'MOTSC-10MG',
  'MOTSC-15MG',
  'MOTSC-20MG',
  'MOTSC-40MG',
  'NAD-1000MG',
  'NAD-100MG',
  'NAD-500MG',
  'OREXINA-10MG',
  'OREXINB-10MG',
  'OREXINB-5MG',
  'OXITOCINA-10MG',
  'OXITOCINA-2MG',
  'OXITOCINA-5MG',
  'P21-5MG',
  'PE2228-10MG',
  'PEGMGF-2MG',
  'PINEALON-10MG',
  'PINEALON-20MG',
  'PINEALON-5MG',
  'PNC27-10MG',
  'PNC27-5MG',
  'PT141-10MG',
  'PTD1-5MG',
  'PTDDBM-1MG',
  'RETATRUTIDA-100MG',
  'RETATRUTIDA-10MG',
  'RETATRUTIDA-120MG',
  'RETATRUTIDA-15MG',
  'RETATRUTIDA-20MG',
  'RETATRUTIDA-30MG',
  'RETATRUTIDA-40MG',
  'RETATRUTIDA-5MG',
  'RETATRUTIDA-60MG',
  'RETATRUTIDE20M-60MG',
  'SELANK-10MG',
  'SELANK-5MG',
  'SEMAGLUTIDA-10MG',
  'SEMAGLUTIDA-15MG',
  'SEMAGLUTIDA-20MG',
  'SEMAGLUTIDA-2MG',
  'SEMAGLUTIDA-30MG',
  'SEMAGLUTIDA-50MG',
  'SEMAGLUTIDA-5MG',
  'SEMAX-10MG',
  'SEMAX-5MG',
  'SERMORELINA-10MG',
  'SERMORELINA-2MG',
  'SERMORELINA-5MG',
  'SLUPP332-5MG',
  'SNAP8-100MG',
  'SNAP8-10MG',
  'SOMATROPINAHGH-10IU',
  'SOMATROPINAHGH-12IU',
  'SOMATROPINAHGH-15IU',
  'SS31-10MG',
  'SS31-50MG',
  'SURVODUTIDE-10MG',
  'TB500-10MG',
  'TB500-2MG',
  'TB500-5MG',
  'TESAMORELIN10I-15MG',
  'TESAMORELINA-10MG',
  'TESAMORELINA-20MG',
  'TESAMORELINA-2MG',
  'TESAMORELINA-5MG',
  'THYMALIN-10MG',
  'THYMOSINALPHA1-10MG',
  'THYMOSINALPHA1-5MG',
  'TIRZEPATIDA-100MG',
  'TIRZEPATIDA-10MG',
  'TIRZEPATIDA-120MG',
  'TIRZEPATIDA-20MG',
  'TIRZEPATIDA-30MG',
  'TIRZEPATIDA-40MG',
  'TIRZEPATIDA-50MG',
  'TIRZEPATIDA-60MG',
  'TRIPTORELINACE-2MG',
  'VIP-10MG',
  'VIP-5MG',
  'VITAMINAB12-10MG',
  'VITAMINAD3-10ML',
  'Viales genericos para fotos de contenido',
]);
